import { cn } from "@util/tailwind";
import type { SessionStatus } from "@type/training";
import { formatSessionStatus } from "@type/training";

// Colour only. The LABEL is the BE status shown verbatim (just cased and
// de-underscored) — per BE, the FE must NOT remap statuses (e.g. "started" must
// read "Started", not "In Progress"). The BE owns the status vocabulary, so any
// unknown status still renders with a neutral colour rather than breaking.
const STATUS_COLORS: Record<string, string> = {
    invited:     "bg-gray-50 text-gray-700 border-gray-200",
    started:     "bg-amber-50 text-amber-700 border-amber-200",
    in_progress: "bg-amber-50 text-amber-700 border-amber-200",
    scoring:     "bg-blue-50 text-blue-700 border-blue-200",
    completed:   "bg-emerald-50 text-emerald-700 border-emerald-200",
    failed:      "bg-rose-50 text-rose-700 border-rose-200",
    expired:     "bg-rose-50 text-rose-700 border-rose-200",
    abandoned:   "bg-amber-50 text-amber-700 border-amber-200",
};

const DEFAULT_STATUS_COLOR = "bg-gray-50 text-gray-700 border-gray-200";

interface Props {
    status: SessionStatus;
    className?: string;
}

export function TrainingStatusPill({ status, className }: Props) {
    return (
        <span
            className={cn(
                "inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-semibold",
                STATUS_COLORS[status] ?? DEFAULT_STATUS_COLOR,
                className,
            )}
        >
            {formatSessionStatus(status)}
        </span>
    );
}
